import { HashRouter, Route, Routes, Link } from "react-router-dom";
import React, { lazy, Suspense } from "react";
const Home = lazy(() => import("../pages/home/index")); // 首页
const WinSlotsPage = lazy(() => import("../pages/WinSlotsPage/index")); // win slots 落地页
const SlotSelect = lazy(() => import("../pages/slotSelect/index")); // slot 选择

const router:any = [
  {
    path: "/",
    element: <WinSlotsPage />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/slotSelect",
    element: <SlotSelect />,
  },
];

function appRouter() {
  return (
    <Suspense>
      <HashRouter>
        <Routes>
          {router.map((val:any,index:number) => {
            return <Route key={index} path={val.path} element={val.element} />;
          })}
        </Routes>
      </HashRouter>
    </Suspense>
  );
}

export default appRouter;
